import { useRouter } from 'next/router';
import React, {
  Dispatch,
  FunctionComponent,
  SetStateAction,
  // useCallback,
  // useState,
} from 'react';

// import { useEffectOnce } from 'usehooks-ts';
import RichText from 'components/RichText/RichText';
import { useCopyStore } from 'store';
// import {
//   setCursorLabel,
//   triggerDefaultCursor,
//   triggerScaleUpCursor,
// } from 'utils/cursorController';
import { OfficeCMS } from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from './List.styles';

export interface ListProps {
  list: OfficeCMS[];
  activeLocation: OfficeCMS | null;
  setActiveLocation: Dispatch<SetStateAction<OfficeCMS>>;
}

const defaultProps: Partial<ListProps> = {
  list: [],
  activeLocation: null,
  setActiveLocation: () => null,
};

const List: FunctionComponent<ListProps> = ({
  list,
  activeLocation,
  setActiveLocation,
  ...rest
}) => {
  const { globalSettings } = useCopyStore(({ copy }) => copy);
  const router = useRouter();

  // const [isHovering, setIsHovering] = useState<boolean>(true);

  const hoverColor =
    globalSettings?.buttonsHoverColor ||
    globalSettings?.buttonsHoverDefaultColors;

  // Disabled by client request, possibly in the future will be turned on.
  // useEffectOnce(() => {
  //   const timeout = setTimeout(() => setIsHovering(false), 2000);

  //   return () => clearTimeout(timeout);
  // });

  // const handleMouseEnter = useCallback(() => {
  //   setIsHovering(true);
  //   triggerScaleUpCursor();
  // }, []);

  // const handleMouseLeave = useCallback(() => {
  //   setIsHovering(false);
  //   setCursorLabel('');
  //   triggerDefaultCursor();
  // }, []);

  const handleOnClick = (props: OfficeCMS) => {
    setActiveLocation(props);

    router.push(
      {
        pathname: router.pathname,
        query: { ...router.query, location: props.heading },
      },
      undefined,
      { shallow: true }
    );
  };

  const handleOnDoubleClick = () => {
    setActiveLocation(null);

    router.push(
      {
        pathname: router.pathname,
        query: {},
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <S.Wrapper
      {...rest}
      // onMouseEnter={handleMouseEnter}
      // onMouseLeave={handleMouseLeave}
      hoverColor={hoverColor}
    >
      {list.map(props => (
        <S.ListItem
          key={props.id}
          tabIndex={0}
          onClick={() => handleOnClick(props)}
          onDoubleClick={handleOnDoubleClick}
          isActive={props.id === activeLocation?.id}
          isHovering={true}
          isSetActiveElement={!!activeLocation}
        >
          <RichText
            as="h4"
            size="heading4"
            richText={props?.heading}
            defaultFormatting
          />
        </S.ListItem>
      ))}
    </S.Wrapper>
  );
};

List.defaultProps = defaultProps;

export default List;
